var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "benchmark-size" }, [
    _c("div", [
      _c("span", { staticClass: "benchmark-size__title" }, [
        _vm._v("Benchmark Classification:")
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "benchmark-size__label label label-info",
          attrs: {
            "data-type": "tooltip",
            "data-title":
              "X Large = 20+ Physicians | Large = 11 - 20 Physicians | Medium = 5 – 10 Physicians | Small = 1 – 4 Physicians"
          }
        },
        [_vm._v(_vm._s(_vm.practiceBenchmark))]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "benchmark-size__subtitle" }, [
      _vm._v("(can change from month-to-month)")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }